<template>
    <div ref="element" class="c-form-element" :class="{ 'c-form-element--horizontal' : horizontal, 'c-form-element--icon' : icon, 'c-form-element--clean' : clean }">
        <div class="c-form-element__label" v-if="label">
            <label v-html="label"></label>
            <div class="font-heading fs-tiny color-gray-600" v-html="sublabel"></div>
            <p class="fs-small color-dark-gray" v-if="helptext">{{helptext}}</p>
        </div>
        <div class="c-form-element__container">
            <div class="c-form-element__input">
                <slot></slot>
            </div>
            <div v-if="errors" class="c-form__error c-form__error--show">
                <template v-for="error in errors">
                    <template v-if="error instanceof Object" v-for="subError in error">
                        <div class="c-form__error--message">{{subError}}</div>
                    </template>
                    <div v-else class="c-form__error--message">{{ error }}</div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'form-element',
    props: {
        horizontal: {
            type: Boolean,
            default: false
        },
        icon: {
            type: Boolean,
            default: false
        },
        clean: {
            type: Boolean,
            default: false
        },
        light: {
            type: Boolean,
            default: false
        },
        password: {
            type: Boolean,
            default: false
        },
        label: {
            type: String
        },
        sublabel: {
            type: String
        },
        helptext: {
            type: String
        },
        name: {
            type: [String,Number,],
            default: null,
        },
    },
    inject: {
        form: {
            default: {
                inputErrors: {},
                hasNewElements: () => {},
            },
        },
    },
    computed: {
        errors() {
            if (this.name == '*') {
                return this.form?.inputErrors;
            }
            return this.form?.inputErrors?.[this.name];
        },
    },
    mounted() {
        this.form.hasNewElements();
    },
}
</script>
